import { useContract } from 'components/contracts/useContract';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { PartialEarlySettlementUi } from './ui';
import { useMyProfile } from 'components/my-profile';

export const PartialEarlySettlement: React.FC<{ contractId: string }> = ({ contractId }) => {
    const { data: contract, isLoading, loadingError } = useContract(contractId);
    const { data: myProfileData, isLoading: isLoadingProfile, loadingError: profileLoadingError } = useMyProfile();
    const PartialEarlySettlementWithHandlers = withLoadingAndNoConnectionHandler(PartialEarlySettlementUi);

    return (
        <PartialEarlySettlementWithHandlers
            isLoading={isLoading || isLoadingProfile}
            contract={contract}
            hasError={!!loadingError || !!profileLoadingError}
            customerType={myProfileData?.identification?.customerType ?? ''}
        />
    );
};
